import React from "react";
import { domain } from "../ajax/Ajax";

class Upload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploading: false,
    };

    this.sendMergeCommand = this.sendMergeCommand.bind(this);
    this.uploadChunks = this.uploadChunks.bind(this);
    this.uploadInputChanged = this.uploadInputChanged.bind(this);

    this.imageInput = React.createRef();
  }

  async sendMergeCommand(upload_id) {
    let formData = new FormData();
    formData.append("upload_id", upload_id);

    try {
      let resp = await fetch(
        domain + "/en/api/shop/v1/chunk-upload/complete/",
        {
          method: "POST",
          body: formData,
        }
      );

      let data = await resp.json();

      this.props.addImageToGallery(data);
      this.setState({
        uploading: false,
      });
    } catch (e) {}
  }

  //The function to upload each file into chunks
  async uploadChunks(file, index) {
    const chunkSize = 1 * 1024 * 100; // The size of each chunk, set to 100 KB. We can even reduce with slow connections

    // Use the Blob.slice method to split the file.
    // This method is also used differently in different browsers.
    const blobSlice =
      File.prototype.slice ||
      File.prototype.mozSlice ||
      File.prototype.webkitSlice;

    const blockCount = Math.ceil(file.size / chunkSize); // Total number of slices

    //Initialize upload_id returned when upload starts
    var upload_id = "";
    for (let i = 0; i < blockCount; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);

      // Build a form
      const form = new FormData();
      form.append("image", blobSlice.call(file, start, end));
      form.append("name", file.name);

      if (i > 0) {
        form.append("upload_id", upload_id);
      }

      let headers = {};
      if (i > 0) {
        headers["Content-Range"] = `bytes ${start}-${end}/${file.size}`;
      }

      this.setState({
        uploading: true,
      });

      try {
        let resp = await fetch(domain + "/en/api/shop/v1/chunk-upload/", {
          method: "POST",
          headers: headers,
          body: form,
        });
        let data = await resp.json();

        upload_id = data.upload_id;

        //If the chunk sent was the last blackCount, we send the command to merge the chunks into one file
        if (i + 1 === blockCount) {
          await this.sendMergeCommand(upload_id);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  async uploadInputChanged(event) {
    let files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      await this.uploadChunks(files[i], i);
    }
  }

  render() {
    let uploading = "";
    if (this.state.uploading) {
      uploading = "is-loading";
    }
    return (
      <div>
        <button
          type="button"
          onClick={() => {
            this.imageInput.current.click();
          }}
          title="Add image"
          className={"button is-round is-info " + uploading}
        >
          <span className="zmdi zmdi-plus"></span>
        </button>
        <input
          multiple
          onChange={this.uploadInputChanged}
          ref={this.imageInput}
          type="file"
          className="is-hidden"
        />
      </div>
    );
  }
}

export default Upload;
